import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MenuSection from './components/MenuSection';
import InfoSection from './components/InfoSection';
import AccessSection from './components/AccessSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';
import ScrollToTopButton from './components/ScrollToTopButton';

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    const revealElements = document.querySelectorAll('.reveal, .reveal-stagger');
    revealElements.forEach((el) => observer.observe(el));

    return () => {
      revealElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <MenuSection />
      <InfoSection />
      <AccessSection />
      <ContactSection />
      <FooterSection />
      <ScrollToTopButton />
    </main>
  );
}